import React, { useState, useContext } from "react";
import ic_mirror_1 from "../img/ic_mirror_1.png";
import ic_shopping_cart from "../img/ic_shopping_cart_parts.png";
import { useNavigate, Link } from "react-router-dom";
import ic_no_image from "../img/ic_no_image_available_big.png";
import "../css/ItemSingleCard.css";
import { ShoppingCartContext } from "./ShoppingCartContext";

function ItemSingleCard(props) {


    // const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext)

    // // console.log(" shoppingCart in ItemSingleCard ", shoppingCart)

    // const { item, setShowCartSidebar } = props;

    // const [imageNotAvailable, setImageNotAvailable] = useState(false);

    // let itemCodeWithoutSpace = item.Code.split(" ").join("");

    // let trimmedItemCode = item.Code.trim();

    // let specialCharacterRemovedItemCode = encodeURIComponent(trimmedItemCode);

    // const checkIfItemAlreadyPresentInCart = (itemFromParent) => {
    //     return shoppingCart.some((itemInArray) => {
    //         return itemInArray.Code == itemFromParent.Code
    //     })
    // }

    // const clickedOnShoppingCart = (itemFromClick) => {

    //     console.log("current context is shoppingCart ", shoppingCart, itemFromClick)

    //     let updatedItemWithQuantity = { ...itemFromClick, quantity_in_shopping_cart: 1 }

    //     if (shoppingCart.length != 0) {

    //         if (checkIfItemAlreadyPresentInCart(itemFromClick)) {

    //             const updatedArrayWithQuantityIncremented = shoppingCart.map((itemInArray) => {
    //                 if (itemInArray.Code == itemFromClick.Code) {
    //                     return { ...itemInArray, quantity_in_shopping_cart: itemInArray.quantity_in_shopping_cart + 1 }
    //                 } else {
    //                     return itemInArray
    //                 }
    //             })

    //             setShoppingCart(updatedArrayWithQuantityIncremented)

    //         } else {
    //             setShoppingCart([...shoppingCart, updatedItemWithQuantity])
    //         }


    //     } else {
    //         setShoppingCart([updatedItemWithQuantity])
    //     }

    //     // now show sidebar optimise it to show after items updated is confirmed

    //     setShowCartSidebar(true)
    // }

    // const addDefaultSrc = (ev, itemName) => {
    //     console.log("error loading image of ", itemName)
    //     ev.target.style.display = 'none';
    //     console.log("ev.target.nextElementSibling  ", ev.target.nextElementSibling)

    //     //ev.target.nextElementSibling.src ="../img/ic_no_image_available_big.png"
    //     ev.target.nextElementSibling.style.display = 'block';
    // }

    return (

        <div className="ItemSingleCard-root-container">

            <div className="ItemSingleCard-inner-container">

                {/* <Link
                    to={"/item_details?prod_id=" + specialCharacterRemovedItemCode}
                    className="ItemCard-link-to-detail-page-img d-block"
                >
                    <img className="ItemSingleCard-inner-container-item-image" src={`http://autoland.fortiddns.com:83/${specialCharacterRemovedItemCode}.jpg`}
                        onError={(e) => addDefaultSrc(e, item.group)} />

                    <img className="hidden-image-if-error" src={ic_no_image} />

                 
                </Link>

                <Link
                    to={"/item_details?prod_id=" + specialCharacterRemovedItemCode}
                    className="ItemCard-link-to-detail-page-name d-block"
                >
                    <label className="Item-product-name mt-2" title={item.Description}>{item.Description}</label>
                </Link>

                <div className="parts-b-g-y-panel mt-2">
                    <div>{item.Brand?.length > 0 ? item.Brand : "_" } </div>
                    <div>{item.Group?.length > 0 ? item.Group : "_"} </div>
                    <div>{item.Year?.length > 0 ? item.Year : "_"} </div>
                    <div>{item.Model?.length > 0 ? item.Model : "_"} </div>
                    <div className="parts_qty_box">Qty {item.Qty} </div>
                </div>

                <div className="d-flex justify-content-between mt-2 ItemSingleCard_bottom_panel_with_aed_and_cart">
                    <span><label className="Item-price-currency-label me-1">AED</label>{item.Price} </span>
                    <img className="Item-shopping-cart-image" onClick={() => clickedOnShoppingCart(item)} src={ic_shopping_cart} />
                </div> */}
            </div>

        </div>
    )
}

export default ItemSingleCard;